import { InputSizeX } from '.';

export const inputWidths: Record<InputSizeX, string> = {
  full: '100%',
  lg: '300px',
  md: '262px',
  sm: '200px',
  xs: '150px',
  xxs: '80px',
  xxxs: '64px',
};
